/// <reference path="../../app.typings.d.ts" />
'use strict';
var app;
(function (app) {
    var Reporting;
    (function (Reporting) {
        var ReportDisplayController = /** @class */ (function () {
            function ReportDisplayController($q, $routeParams, $scope, $sce, $compile, $document, $timeout, $window, applicationService, applicationApiService, csvParserService, httpService, locationService, modalService, activeReport, organizationCacheKey, organizationList) {
                this.$q = $q;
                this.$routeParams = $routeParams;
                this.$scope = $scope;
                this.$sce = $sce;
                this.$compile = $compile;
                this.$document = $document;
                this.$timeout = $timeout;
                this.$window = $window;
                this.applicationService = applicationService;
                this.applicationApiService = applicationApiService;
                this.csvParserService = csvParserService;
                this.httpService = httpService;
                this.locationService = locationService;
                this.modalService = modalService;
                this.activeReport = activeReport;
                this.organizationCacheKey = organizationCacheKey;
                this.organizationList = organizationList;
                this.init();
            }
            ReportDisplayController.prototype.init = function () {
                var _this = this;
                // Resize viewable report area on window resize
                jQuery(window).resize(function () {
                    _this.configureDisplay();
                });
                this.applicationService.getActiveReport().then(function (activeReport) {
                    // Handling for activeReport === undefined handled in getActiveReport()
                    if (_this.$routeParams.report.toLowerCase() !== activeReport.ssrsName.toLowerCase()) {
                        _this.applicationService.updateReportRoute(_this.$routeParams.report).then(function () {
                            _this.applicationService.getActiveReport().then(function (newActiveReport) {
                                _this.initReportProcess(newActiveReport);
                            });
                        });
                    }
                    else {
                        _this.initReportProcess(activeReport);
                    }
                });
            };
            ReportDisplayController.prototype.initReportProcess = function (activeReport) {
                this.$scope.activeReport = activeReport;
                this.$scope.isGroupReport = this.$scope.activeReport.isGroupLevel;
                this.parseReportParams();
            };
            //returns either the correct default alpha org based on the choice of org from avenue, or null when it searches a sub-tree and does not find it there
            ReportDisplayController.prototype.getDefaultAlpha = function (alphaList, currentOrgKey) {
                var defaultOrg = null, org, result;
                for (var count = 0; count < alphaList.length; count++) {
                    org = alphaList[count];
                    if (org.cacheKey === currentOrgKey) {
                        defaultOrg = org;
                        break;
                    }
                    else {
                        if (!ap.Utilities.isNullOrUndefined(org.subOrganizationUnits) &&
                            org.subOrganizationUnits.length > 0) {
                            result = this.getDefaultAlpha(org.subOrganizationUnits, currentOrgKey);
                            if (!ap.Utilities.isNullOrUndefined(result)) {
                                //if we found the org chosen in avenue in this tree, bubble upwards and then select the alpha at the top
                                defaultOrg = org;
                                break;
                            }
                        }
                        else if (!ap.Utilities.isNullOrUndefined(org.childOrganizationUnits) &&
                            org.childOrganizationUnits.length > 0) {
                            result = this.getDefaultAlpha(org.childOrganizationUnits, currentOrgKey);
                            if (!ap.Utilities.isNullOrUndefined(result)) {
                                //if we found the org chosen in avenue in this tree, bubble upwards and then select the alpha at the top
                                defaultOrg = org;
                                break;
                            }
                        }
                    }
                }
                return defaultOrg;
            };
            ReportDisplayController.prototype.configureDisplay = function () {
                var $parent = jQuery('.white-surround'), parentHeight = $parent.outerHeight(), siblingHeight = 0, $er = jQuery('#reports-loader'), $siblings = $er.prevAll();
                for (var i = 0; i < $siblings.length; i++) {
                    var $sibling = angular.element($siblings[i]);
                    siblingHeight += $sibling.height();
                }
                var element = $parent.find('#reports-loader');
                var newHeight = parentHeight - siblingHeight;
                if (newHeight <= 0) {
                    newHeight = 700;
                }
                if ($er.height() > 0 && $er.innerHeight() > newHeight) {
                    newHeight = $er.innerHeight();
                }
                element.height(newHeight);
            };
            ReportDisplayController.prototype.openReportConfig = function () {
                var _this = this;
                var editOptions = {
                    headerText: 'Filter Report',
                    bodyText: '',
                    actionButtonText: 'Run',
                    closeButtonText: 'Cancel',
                    activeReport: this.$scope.activeReport
                };
                if (!this.$scope.activeReport.isWpReport) {
                    this.modalService.openMultipointReportConfigModal(editOptions).then(function (result) {
                        if (result.action === ModalActionResult.Saved) {
                            _this.applicationService.getActiveReport().then(function (activeReport) {
                                _this.$scope.activeReport = activeReport;
                                _this.runReport();
                            });
                        }
                    });
                }
                else {
                    this.modalService.openEditReportConfigModal(editOptions).then(function (result) {
                        if (result.action === ModalActionResult.Saved) {
                            _this.applicationService.getActiveReport().then(function (activeReport) {
                                _this.$scope.activeReport = activeReport;
                                _this.parseReportParams();
                                _this.runReport();
                            });
                        }
                    });
                }
            };
            ReportDisplayController.prototype.parseReportParams = function () {
                this.$scope.reportFormats = ap.Constants.downloadOptions;
                if (this.$scope.activeReport.isWpReport) {
                    this.$scope.reportParams = this.applicationService.reportParameters;
                    this.$scope.reportFormats[0].active = true;
                    this.$scope.reportFormats[1].active = false;
                    this.$scope.reportFormats[2].active = false;
                }
                else {
                    this.$scope.dealerCacheKey = this.applicationService.getDealerKey();
                }
                this.updateReportData();
            };
            ReportDisplayController.prototype.runReport = function () {
                var _this = this;
                this.$scope.reportLoading = true;
                this.$scope.reportTitle = this.$scope.activeReport.name;
                if (this.$scope.activeReport.isWpReport && !ap.Utilities.isNullOrUndefined(this.$scope.reportParams)) {
                    if (!ap.Utilities.isNullOrUndefined(this.applicationService.reportParameters.rptBeginDate) &&
                        !(this.$scope.reportParams.rptBeginDate instanceof Date)) {
                        this.$scope.reportParams.rptBeginDate = new Date(this.applicationService.reportParameters.rptBeginDate);
                    }
                    if (!ap.Utilities.isNullOrUndefined(this.$scope.reportParams.rptEndDate) &&
                        !(this.$scope.reportParams.rptEndDate instanceof Date)) {
                        this.$scope.reportParams.rptEndDate = new Date(this.applicationService.reportParameters.rptEndDate);
                    }
                    if (!ap.Utilities.isNullOrUndefined(this.$scope.reportParams.arrivalType)) {
                        this.$scope.displayArrivalType =
                            ap.Constants.writeUpTypes[this.$scope.reportParams.arrivalType].value;
                    }
                }
                var surround = this.$document.find('.white-surround .panel');
                surround.scrollTop(-100);
                if (!this.$scope.activeReport.isWpReport) {
                    var rlContainer_1 = this.$document.find('#reports-loader'), reportPath = this.$scope.activeReport.ssrsPath;
                    this.applicationApiService.getReport(this.$scope.activeReport, reportPath).then(function (reportUrl) {
                        _this.httpService.get(reportUrl).then(function (returnedReport) {
                            _this.$scope.reportLoading = false;
                            var formattedReport = _this.$compile(returnedReport)(_this.$scope);
                            rlContainer_1.html(formattedReport);
                            _this.$timeout(function () {
                                // Report Server taking longer to load, delay this slightly
                                _this.processReportHeaders().then(function (success) {
                                    if (success === 'true') {
                                        _this.$scope.reportLoading = false;
                                    }
                                });
                            });
                        });
                    });
                }
                else {
                    // Welcome Point Reports
                    this.applicationApiService
                        .getWelcomepointReport(this.$scope.reportParams, this.$scope.activeReport.ssrsPath)
                        .then(function (result) {
                        _this.displayReport(result);
                    });
                }
            };
            // Makes headers fixed on report display
            ReportDisplayController.prototype.processReportHeaders = function () {
                var _this = this;
                this.configureDisplay();
                return this.$q(function (resolve) {
                    // Find row with alt text
                    var rlContainer = _this.$document.find('#reports-loader'), headerRow = rlContainer.find('td[alt="fixedHeaderRow"]').parent(), wsContainer = _this.$document.find('.white-surround');
                    if (!ap.Utilities.isNullOrUndefined(headerRow) && headerRow.length > 0) {
                        headerRow.parent('table').css('margin-top', headerRow.height());
                        _this.setScrollBehavior(headerRow, wsContainer, rlContainer);
                        angular.element(_this.$window).on('resize', function () {
                            // this will mis-fire if floating header is active, so scrollTop to deactivate
                            _this.$document.find('.white-surround .panel').scrollTop(0);
                            // Set up widths, etc. again after resize
                            _this.setScrollBehavior(headerRow, wsContainer, rlContainer);
                        });
                        resolve('true');
                    }
                    else {
                        resolve('true');
                    }
                });
            };
            ReportDisplayController.prototype.setCellWidths = function (headerRow) {
                var headerCells = headerRow.find('td');
                // add css inline for width fixing
                angular.forEach(headerCells, function (cell, index) {
                    cell = angular.element(cell);
                    var cellWidth = cell.width();
                    cell.attr('width', cellWidth)
                        .removeAttr('alt', '')
                        .removeAttr('title', '')
                        .width(cellWidth);
                });
            };
            ReportDisplayController.prototype.setScrollBehavior = function (headerRow, wsContainer, rlContainer) {
                headerRow = angular.element(headerRow);
                wsContainer = angular.element(wsContainer);
                rlContainer = angular.element(rlContainer);
                var panel = this.$document.find('.white-surround .panel'), initialLoad = true, leftOffset = headerRow.offset().left + 1.5, topOffset = wsContainer.offset().top;
                this.setCellWidths(headerRow);
                // Turn scroll off before re-setting in case function gets called again on resize
                panel.off('scroll');
                panel.scroll(function () {
                    var totalOff = topOffset - panel.scrollTop();
                    // add necessary css in-line for position absolute (or class)
                    if (totalOff <= 15) {
                        headerRow.addClass('fixedHeaderRow');
                        headerRow.css('top', topOffset).css('left', leftOffset);
                        // @TODO: Remove soon, this is a Band-Aid that Jay says will get obsoleted once a few things get fixed
                        if (initialLoad) {
                            var firstCell = headerRow.find('td:first-child');
                            if (firstCell.width() < 11) {
                                var firstCellOw = firstCell.outerWidth();
                                leftOffset = leftOffset - firstCellOw;
                                var lastCell = headerRow.find('td:last-child'), lastCellWidth = lastCell.width() + firstCellOw * 1.75;
                                lastCell.width(lastCellWidth).css('width', lastCellWidth);
                            }
                            initialLoad = false;
                        }
                    }
                    else {
                        headerRow.removeClass('fixedHeaderRow');
                    }
                });
            };
            ReportDisplayController.prototype.displayReport = function (result) {
                var _this = this;
                this.$timeout(function () {
                    _this.$scope.reportData = _this.csvParserService.parse(result);
                    _this.$scope.reportLoading = false;
                });
            };
            ReportDisplayController.prototype.downloadReport = function (format) {
                var _this = this;
                var ctrl = this, csvData;
                // if (!this.$scope.reportData && !this.$scope.activeReport.isWpReport) { return; }
                var isTouchDevice = 'ontouchstart' in document.documentElement;
                var a = document.createElement('a');
                if (!this.$scope.activeReport.isWpReport) {
                    this.applicationService.getActiveReport().then(function (activeReport) {
                        _this.$scope.activeReport = activeReport;
                        _this.$scope.activeReport.format = format.type;
                        var date = new Date(), reportName = _this.$scope.activeReport.uiReportName;
                        var alphaParam = _this.$scope.activeReport.parameters.find(function (x) { return x.reportDataTypeId === MetaParameters.AlphaOrg; });
                        var dealerParam = _this.$scope.activeReport.parameters.find(function (x) { return x.reportDataTypeId === MetaParameters.OrganizationUnit; });
                        if (!ap.Utilities.isNullOrUndefined(alphaParam)) {
                            reportName += '_' + alphaParam.displayLabel;
                        }
                        else if (!ap.Utilities.isNullOrUndefined(dealerParam)) {
                            reportName += '_' + dealerParam.displayLabel;
                        }
                        reportName += '_' + date.getFullYear() + '-' + (date.getMonth() + 1) + '-' + date.getDate();
                        reportName += '.' + format.extension;
                        reportName = reportName.replace(/\s/g, '-');
                        var filenameParam = {
                            hide: true,
                            isActive: true,
                            isHidden: true,
                            isRequired: false,
                            name: 'filename',
                            value: reportName
                        };
                        _this.$scope.activeReport.parameters.push(filenameParam);
                        _this.applicationApiService
                            .getReport(_this.$scope.activeReport, _this.$scope.activeReport.ssrsPath)
                            .then(function (reportUrl) {
                            a.href = _this.$sce.trustAsResourceUrl(reportUrl);
                            document.body.appendChild(a);
                            a.click();
                        });
                    });
                }
                else {
                    csvData = this.convertToCSV(this.$scope.reportData);
                    if (isTouchDevice) {
                        var blob = new Blob([csvData], { type: 'text/csv;charset=utf-8;' });
                        a.href = (window.URL || window.webkitURL).createObjectURL(blob);
                    }
                    else {
                        a.href = 'data:text/csv;charset=utf-8,' + encodeURIComponent(csvData);
                        a.target = '_blank';
                        a.download = this.$scope.reportTitle.replace(/\s+/g, '') + '.csv';
                    }
                    document.body.appendChild(a);
                    a.click();
                }
            };
            ReportDisplayController.prototype.updateReportData = function () {
                if (this.locationService.isOnPage(ap.Constants.routes.reportDisplay)) {
                    this.runReport();
                }
            };
            ReportDisplayController.prototype.convertToCSV = function (data) {
                var csv = '';
                if (data && data.rawData) {
                    var rows = data.rawData.split(/\r\n|\n/);
                    for (var _i = 0, rows_1 = rows; _i < rows_1.length; _i++) {
                        var row = rows_1[_i];
                        csv += row.split(/[,|](?=(?:[^"]*"[^"]*")*[^"]*$)/)
                            .map(function (value) { return "\"" + value.replace(/"/g, '""') + "\""; }).join(',') + '\n';
                    }
                }
                else {
                    console.error('Data or rawData is undefined.');
                }
                return csv;
            };
            ReportDisplayController.$inject = [
                '$q',
                '$routeParams',
                '$scope',
                '$sce',
                '$compile',
                '$document',
                '$timeout',
                '$window',
                'applicationService',
                'applicationApiService',
                'csvParserService',
                'httpService',
                'locationService',
                'modalService'
            ];
            return ReportDisplayController;
        }());
        Reporting.ReportDisplayController = ReportDisplayController;
        angular.module('app.Reporting').controller('ReportingController', Reporting.ReportingController);
    })(Reporting = app.Reporting || (app.Reporting = {}));
})(app || (app = {}));
